import { Component, h } from 'preact';

export enum PageAnimationDirection { Left, Right }

interface PageAnimatorProps {
    initialEl: JSX.Element
}

interface PageAnimatorState {
    lastEl: JSX.Element,           
    currentEl: JSX.Element,        
    swap: boolean;
    direction: PageAnimationDirection;
}

export class PageAnimator extends Component<PageAnimatorProps, PageAnimatorState> {
    
    constructor(props:PageAnimatorProps) {
        super(props)

        this.state = {
            lastEl: null,
            currentEl:  props.initialEl,
            swap: true,
            direction: PageAnimationDirection.Left
        }
    }

    animateToElement(newElement: JSX.Element,  direction: PageAnimationDirection): Promise<void> {
       
        this.setState({
            lastEl: this.state.currentEl,
            currentEl: newElement,
            swap: !this.state.swap,
            direction: direction
        })

        return new Promise((resolve) => {
            setTimeout(
                () => { 
                    this.setState({ lastEl: null,});
                    resolve();
                },
                860);
        });
    }

    render(props?: PageAnimatorProps, state?: PageAnimatorState) {
        let animatingClass = (state.direction == PageAnimationDirection.Left) ? "animating-left" : "animating-right"

        const prevPage =  (<div  class="page-navigator-previous">
                        { state.lastEl }
        </div>)  
        const newPage = (<div class="page-navigator-current">
                      { state.currentEl }
                </div>)
        
        return (
            <div class={"page-navigator" + (state.lastEl != null ? " "+animatingClass: "")}>
               {
                   state.swap ? [ newPage, prevPage] : [prevPage, newPage]
               }
            </div>
        )
        
    }
}